import { InjectionToken, ModuleWithProviders, NgModule, Type, inject } from '@angular/core';

import { StatePersistServiceRegistry } from './state-storage-persist-service.registry';
import { StateSaver, _STATE_STORAGE_PERSIST_SERVICE } from './state-storage.model';

@NgModule({})
export class StateStorageFeatureModule {
    constructor() {
        const root = inject(StatePersistServiceRegistry);
        const statePersistServices = inject<{ feature: string; stateSaver: StateSaver<any, any> }[]>(_STATE_STORAGE_PERSIST_SERVICE);

        for (const service of statePersistServices) {
            console.log('Register persist service for feature: ' + service.feature);
            root.register(service.feature, service.stateSaver);
        }
    }
}

@NgModule({})
export class StateStorageModule {
    static forFeature(
        feature: string,
        stateSaver: InjectionToken<StateSaver<any, any>> | Type<StateSaver<any, any>>,
    ): ModuleWithProviders<StateStorageFeatureModule> {
        return {
            ngModule: StateStorageFeatureModule,
            providers: [
                {
                    provide: _STATE_STORAGE_PERSIST_SERVICE,
                    multi: true,
                    useFactory: createStateSaver(feature),
                    deps: [stateSaver],
                },
            ],
        };
    }
}

function createStateSaver(feature: string): (stateSaver: StateSaver<any, any>) => { feature: string; stateSaver: StateSaver<any, any> } {
    return (stateSaver: StateSaver<any, any>) => {
        return {
            feature,
            stateSaver,
        };
    };
}
